import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination, Navigation } from "swiper/modules";

const Explorer = () => {
  const explorerList = [
    "images/explorer1.jpg",
    "images/explorer2.jpg",
    "images/explorer3.png",
  ];
  return (
    <div
      id="explorer"
      className=" relative w-full h-full px-[calc((100%-var(--container))/2)] pt-14 xl:pt-28"
    >
      <div className=" relative w-full h-full grid xl:grid-cols-3 gap-5 xl:gap-10 max-w-screen-xl mx-auto">
        <div data-aos="fade-up" className="xl:col-span-2 mt-6 leading-relaxed ">
          <div>
            <h4 className="mb-5 xl:mb-10 ">모든 커피는 생두에서 시작합니다.</h4>
            <p>
              직접 산지에서 모든 생두의 품질을 확인하고, 신뢰와 믿음을 바탕으로
              생산업자와의 관계 맺고있습니다.
            </p>
            <p className="my-3">
              산지로 부터 직수입되는 생두를 매일 로스팅 하는 커피는 맑고 깨끗한
              최상의 신선함을 제공합니다.
            </p>
            <p>
              Licensed Q Grader Certificate 에 의해 검증된 생두를 통한 최상의
              품질을 보장합니다.
            </p>
          </div>
        </div>
        <div className=" relative w-full  h-full mt-10 xl:mt-0">
          <Swiper
            spaceBetween={20}
            loop={true}
            slidesPerView={1}
            autoplay={{
              delay: 3500,
              disableOnInteraction: false,
              pauseOnMouseEnter: true,
            }}
            speed={1500}
            modules={[Autoplay, Pagination, Navigation]}
            className="swiper relative w-72 h-fit"
          >
            {explorerList.map((v, i) => (
              <SwiperSlide key={i}>
                <div className=" relative w-full h-fit">
                  <div className=" relative w-full h-fit">
                    <img
                      className="!relative w-72 h-96 lg:h-[450px] object-cover object-center rounded-3xl "
                      src={v}
                      alt="product"
                      width={616}
                      height={880}
                    />
                  </div>
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
      </div>
    </div>
  );
};

export default Explorer;
